import { useAppDispatch } from "core/utils";
import { useParams } from "react-router";

import { AidPreferenceClessEditForm } from "src/app/features/EmvKernelProfile/subFeatures/AidPreferenceCless/components/forms/AidPreferenceClessEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../../../components/FeatureButtons/CancelButton";
import { OkButton } from "../../../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName, ResourceVariant } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../../../core/setup/redux/state/tabs/tabState";

export const AidPreferenceClessEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();

    const { emvKernelProfileId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${FORM_ACTION.EDIT}/${emvKernelProfileId}`;

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("emv-kernel-profiles_aidPreferencesCless"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.aidPreferencesClessEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <CancelButton isDisabled={false} url={backUrl} onBeforeNavigate={setTabsDefaultBeforeBack} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AidPreferenceClessEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
